export interface OfferUrlQueryParams {
	newCarOrderId?: string
	porscheCode?: string
	reportSale?: boolean
	vehicleId?: string
}

/** Appends offer query params without encoding — configurator placeholders like `{porscheCode}` must stay literal. */
export const appendOfferQueryParams = (path: string, query?: OfferUrlQueryParams): string => {
	const parts: string[] = []
	if (query?.vehicleId) {
		parts.push(`vehicleId=${query.vehicleId}`)
	}
	if (query?.porscheCode) {
		parts.push(`porscheCode=${query.porscheCode}`)
	}
	if (query?.newCarOrderId) {
		parts.push(`newCarOrderId=${query.newCarOrderId}`)
	}
	if (query?.reportSale) {
		parts.push("reportSale=true")
	}
	return parts.length > 0 ? `${path}?${parts.join("&")}` : path
}
